import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";

const slideLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-180px * 10 - 20px * 9));
  }
`;

const slideRight = keyframes`
  0% {
    transform: translateX(calc(-180px * 9 - 20px * 8));
  }
  100% {
    transform: translateX(0);
  }
`;

const VendorCarouselContainer = styled.div`
  width: 100%;
  background: #000000;
  overflow: hidden;
  padding: 40px 0;
  position: relative;
`;

const CarouselRow = styled.div`
  position: relative;
  padding: 20px 0;
  overflow: hidden;
`;

const CarouselTrack = styled.div`
  display: inline-flex;
  gap: 20px;
  white-space: nowrap;

  &.left {
    animation: ${slideLeft} 15s linear infinite;
  }

  &.right {
    animation: ${slideRight} 15s linear infinite;
  }
`;

const VendorCard = styled.div`
  flex: 0 0 180px;
  height: 90px;
  background: rgba(30, 30, 30, 0.5);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  user-select: none;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: brightness(0) invert(1);
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
  }
`;

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 180px;
  pointer-events: none;
  z-index: 2;

  &.left {
    left: 0;
    background: linear-gradient(to right, #000000 0%, transparent 100%);
  }

  &.right {
    right: 0;
    background: linear-gradient(to left, #000000 0%, transparent 100%);
  }
`;

// Разделяем логотипы на два ряда
const firstRowLogos = [
  "/img/vendors/fortinet_logo.svg",
  "/img/vendors/checkpoint_logo.png",
  "/img/vendors/paloalto_logo.png",
  "/img/vendors/cisco_logo.png",
  "/img/vendors/juniper_logo.png",
  "/img/vendors/huawei_logo.svg",
  "/img/vendors/kaspersky_logo.png",
  "/img/vendors/positivetech_logo.svg",
  "/img/vendors/securitycode_logo.png",
  "/img/vendors/b4com_logo.png",
];

const secondRowLogos = [
  "/img/vendors/eltex_logo.png",
  "/img/vendors/bdcom_logo.svg",
  "/img/vendors/qtech_logo.webp",
  "/img/vendors/asterfusion_logo.svg",
  "/img/vendors/vipnet_logo.svg",
  "/img/vendors/snr_logo.png",
  "/img/vendors/usergate_logo.png",
  "/img/vendors/mikrotik_logo.png",
  "/img/vendors/dlink_logo.png",
];

export const Vendors = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <div id="vendors" style={{ marginTop: 40 }}>
        <div className="container">
          <div className="section-title text-center">
            <h2>{t("Vendors.vendorsTitle")}</h2>
          </div>
        </div>
        <VendorCarouselContainer>
          <GradientOverlay className="left" />
          <GradientOverlay className="right" />
          
          {/* First row - moving left */}
          <CarouselRow>
            <CarouselTrack className="left">
              {[...firstRowLogos, ...firstRowLogos].map((logo, index) => (
                <VendorCard key={`row1-${index}`}>
                  <img 
                    src={logo} 
                    alt={`Vendor ${index + 1}`} 
                    draggable="false"
                  />
                </VendorCard>
              ))}
            </CarouselTrack>
          </CarouselRow>

          {/* Second row - moving right */}
          <CarouselRow>
            <CarouselTrack className="right">
              {[...secondRowLogos, ...secondRowLogos].map((logo, index) => (
                <VendorCard key={`row2-${index}`}>
                  <img 
                    src={logo} 
                    alt={`Vendor ${index + 1}`} 
                    draggable="false"
                  />
                </VendorCard>
              ))}
            </CarouselTrack>
          </CarouselRow>
        </VendorCarouselContainer>
      </div>
    </div>
  );
};
